export const cmdImport = 'gjs-open-import-webpage';
export const cmdDeviceDesktop = 'set-device-desktop';
export const cmdDeviceTablet = 'set-device-tablet';
export const cmdDeviceTabletHorizontal = 'set-device-tablet-horizontal';
export const cmdDeviceMobile = 'set-device-mobile';
export const cmdClear = 'canvas-clear';
